import React, { Component } from "react";
import { Loader } from "ui-kit-ck-consultant";

import axiosConfig from "../../../utils/axiosConfig";
import WidgetWrapper from "./WidgetWrapper";
import CardSatisfactionGroup from "../CardSatisfactionGroup";

export default class WidgetSatisfaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      data: null,
    };
  }

  componentDidMount() {
    axiosConfig("home/get-satisfaction").then((res) => {
      if (res.data.success) {
        this.setState({ data: res.data.data, isLoad: false });
      } else {
        this.setState({ isLoad: false });
      }
    }).catch(() => {
      this.setState({ isLoad: false });
    });
  }

  render() {
    return (
      <WidgetWrapper
        title="Satisfaction Groupe"
        noCard
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {this.state.isLoad ? (
          <Loader />
        ) : (
          <CardSatisfactionGroup
            isLoad={false}
            data={this.state.data}
          />
        )}
      </WidgetWrapper>
    );
  }
}
